import React from 'react';

/**
 * กันไม่ให้วิดีโอฝังพังทั้งหน้า
 *
 * react-tiktok เขียนไว้ว่า `<div>Error: {error}</div>` โดยที่ error เป็น Error object
 * ซึ่ง React วาดไม่ได้ -- มันจึง throw ออกมา และเพราะไม่มีใครรับ React เลยถอดทั้งหน้าทิ้ง
 * หน้าที่พักทั้งหน้าจึงขาวไปเฉย ๆ กดจองต่อไม่ได้
 *
 * ทริกเกอร์คือตอนที่ TikTok ตอบ 429 (ยิงถี่เกิน) หรือเน็ตสะดุด ซึ่งเป็นเรื่องนอกการควบคุมเรา
 * และเกิดซ้ำได้ตลอด แก้ที่ไลบรารีไม่ได้เพราะอยู่ใน node_modules (หายตอน install ใหม่)
 *
 * วิดีโอรีวิวเป็นของประกอบ ไม่ใช่ของที่ขาดไม่ได้ -- ถ้าโหลดไม่ได้ให้หายไปเงียบ ๆ
 * ดีกว่าพาหน้าจองทั้งหน้าไปด้วย
 */
class SafeEmbed extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // ไม่ใช้ console.error เพราะ CRA เอา error ขึ้นทับจอเต็มหน้าจอตอน dev
    // ทั้งที่เคสนี้เราตั้งใจกลืนมันแล้ว
    console.warn('[SafeEmbed] วิดีโอฝังโหลดไม่ได้ ข้ามไป:', error && error.message);
  }

  render() {
    if (this.state.failed) return this.props.fallback || null;
    return this.props.children;
  }
}

export default SafeEmbed;
